import styled from "styled-components";

/**
 * Header do componente SubHeaderContainer.
 */
export const SubHeaderContainer = styled.div`
  padding: ${({ theme }) => theme.spacing(1.5)}
    ${({ theme }) => theme.spacing(5)} ${({ theme }) => theme.spacing(1)};
  background-color: ${({ theme }) => theme.colors.lightGray};
  grid-template-columns: auto 1fr auto;
  justify-content: space-between;
  align-items: center;
  display: grid;
`;

/*
 * Logo da companhia aérea.
 */
export const AirportInfo = styled.div`
  gap: ${({ theme }) => theme.spacing(0.65)};
  align-items: center;
  display: flex;

  & > p {
    text-transform: capitalize;
`;

/**
 * Ícone de detalhes do voo.
 */
export const FlightDetailsIcon = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.small};
  border: 2.5px solid ${({ theme }) => theme.colors.black};
  padding-top: ${({ theme }) => theme.spacing(0.75)};
  width: ${({ theme }) => theme.spacing(6)};
  align-items: center;
  position: relative;
  display: flex;

  &::before,
  &::after {
    background-color: ${({ theme }) => theme.colors.black};
    border-radius: ${({ theme }) => theme.spacing(0.25)};
    top: ${({ theme }) => theme.spacing(-0.75)};
    width: ${({ theme }) => theme.spacing(0.4)};
    height: ${({ theme }) => theme.spacing(1)};
    position: absolute;
    content: "";
  }

  &::before {
    box-shadow: ${({ theme }) => theme.spacing(1.75)} 0 0
      ${({ theme }) => theme.colors.black};
    left: ${({ theme }) => theme.spacing(0.65)};
  }

  &::after {
    right: ${({ theme }) => theme.spacing(0.65)};
    content: "";
  }

  & > svg {
    border-top: 2.5px solid ${({ theme }) => theme.colors.black};
    margin-bottom: ${({ theme }) => theme.spacing(-0.25)};
    height: ${({ theme }) => theme.spacing(3.5)};
    width: ${({ theme }) => theme.spacing(6)};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding-top: ${({ theme }) => theme.spacing(0.5)};
    width: ${({ theme }) => theme.spacing(4)};
    height: ${({ theme }) => theme.spacing(4)};

    &::before,
    &::after {
      width: ${({ theme }) => theme.spacing(0.3)};
      height: ${({ theme }) => theme.spacing(0.75)};
      top: ${({ theme }) => theme.spacing(-0.5)};
    }

    &::before {
      box-shadow: ${({ theme }) => theme.spacing(1.25)} 0 0
        ${({ theme }) => theme.colors.black};
      left: ${({ theme }) => theme.spacing(0.4)};
    }

    &::after {
      right: ${({ theme }) => theme.spacing(0.4)};
    }

    & > svg {
      height: ${({ theme }) => theme.spacing(2.5)};
      width: ${({ theme }) => theme.spacing(4)};
    }
  }
`;

/**
 * Container principal dos detalhes do voo.
 */
export const FlightDetailsInfo = styled.div`
  margin-left: ${({ theme }) => theme.spacing(5)};
  flex-direction: column;
  display: flex;

  @media (max-width: 450px) {
    margin-left: ${({ theme }) => theme.spacing(2)};

    & * {
      font-size: 0.6rem; /* Reduz o tamanho da fonte proporcionalmente */
    }
  }
`;
